<template>
  <div class="mes">
    <div class="mes-verify">
      <div class="title">{{mes}}</div>
      <div class="mes1-box clearfix">
        <span class="to">{{to}}</span>
        <span class="tel">{{tel}}</span>
      </div>
      <VerifyCode :num="6" type="number" @fillCb="fill" ref="vc"></VerifyCode>
      <div class="mes2-box clearfix" v-if="isCountdown">
        <div class="count">{{count}}{{countText}}</div>
      </div>
      <div class="mes2-box clearfix" v-else>
        <div class="again" @click="getCode">{{again}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { setPageTitle } from '@didi/public-sdk'
import { showAlert, toast } from '../api'
import { urlObj } from '../config'
import VerifyCode from '../components/VerifyCode'
import {fetchPost, fetchGet} from 'common-js/api/http.js'
import { oMegaData, name_auth_omega_summary } from 'common-js/omega'
import { is } from 'common-js/util/env'
import url from 'common-js/util/url'
import { defaultBiz } from '../config/utils'

export default {
  props: {
    useType: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      code: '',
      mes: '请输入验证码',
      imgSrc: '',
      refreshText: '点击刷新',
      to: '验证码已发送至',
      tel: '',
      no: '收不到验证码',
      again: '重新获取',
      isCountdown: false,
      count: 60,
      maxCount: 60,
      countText: 's后重新获取',
      timer: ''
    }
  },
  computed: {
    ...mapGetters(['ticket', 'unVerified']),
  },
  mounted () {
    setPageTitle({ title: '' })
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    init () {
      this.type = this.$route.query.type || this.useType
      this.getCode()
    },
    async getCode () {
      const res = await fetchGet({
        url: urlObj.getCode,
        params: {
          ticket: this.ticket || '',
          type: this.type,
          risk: window.GlobalSet.query || {}
        }
      })
      const { errno, data, errmsg } = res
      oMegaData(name_auth_omega_summary['pub_trinity_verification_sw_bt'], {
        errno,
        errmsg,
        type: 'digital'
      })
      if (errno * 1 === 0) {
        const { phone } = data
        this.tel = phone
        this.changeNum()
      } else if (errno * 1 === 5001) {
        console.log('ImgVerify')
        this.$router.replace({
          name: 'ImgVerify',
          query: {
            type: this.type
          }
        })
      } else {
        showAlert(this, {
          content: errmsg || '好像出错了，请稍后再试'
        })
      }
    },
    async checkCode (code) {
      const _this = this
      const res = await fetchPost({
        url: urlObj.checkCode,
        data: {
          ticket: this.ticket,
          type: this.type,
          code: code
        }
      })
      const { errno, errmsg } = res
      oMegaData(name_auth_omega_summary['pub_trinity_verification_sw_bt'], {
        errno,
        errmsg,
        type: 'digital'
      })
      if (errno * 1 === 0) {
        toast(_this, {
          txt: '短信验证成功',
          type: 'correct',
          time: 1000,
          onTimeout: () => {
            // 不是司机端且未实名，跳转到实名认证
            if (!is.driver && !_this.unVerified) {
              const to = encodeURIComponent(`https://page.udache.com/general/pages/name-auth/index.html${location.search}`)
              const realNameVerifyURL = `//page.udache.com/middle-platform/name-identity/1.1.0/index.html#/?biz=${defaultBiz()}&bizId=100&step=card&defaultSucc=${to}`
              url.go(realNameVerifyURL, {}, true)
              return false
            }
            if (is.driver) {
              _this.$router.replace({
                name: 'nameID',
                query: {
                  type: _this.type
                }
              })
              return false
            }
            _this.$router.replace({
              // name: 'nameID',
              name: 'MergeNameInfoByBank',
              query: {
                type: _this.type
              }
            })
          }
        })
      } else if (errno * 1 === 6005) {
        toast(_this, { txt: '验证码错误', type: 'warn', time: 1000 })
        this.$refs.vc.clear()
      } else {
        showAlert(_this, {
          content: res.errmsg || '好像出错了，请稍后再试'
        })
      }
    },
    fill (code) {
      // window.dd.loading({timeout: 5000})
      this.checkCode(code)
    },
    changeNum () {
      this.timer = setInterval(() => {
        this.count--
        this.countdown()
      }, 1000)
      this.isCountdown = true
    },
    countdown () {
      if (this.count === 0) {
        clearInterval(this.timer)
        this.isCountdown = false
        this.count = this.maxCount
      }
    }
  },
  components: {
    VerifyCode,
  }
}
</script>
<style lang="scss">
@import '~common-css/mixins.scss';
.mes{
    position: absolute;
    width: 100%;
    height: 100%;
    background: #fff;
    .mes-verify {
        width: px2rem(558);
        font-family: "PingFangSC-Regular", "Microsoft YaHei", "Arial", "sans-serif";
        padding-top: px2rem(132);
        margin: 0 auto;
        .clearfix:after {
            display: table;
            content: "";
            height: 0;
            clear: both;
        }
        .mes-title {
            font-family: "PingFangSC-Medium", "STHeitiSC-Medium", "HelveticaNeue-Medium";
            font-size: px2rem(48);
            text-align: left;
            color: #333;
        }
        .mes1-box {
            font-size: px2rem(28);
            color: #333;
            margin: px2rem(8) 0 px2rem(120);
            .to {
                float: left;
            }
            .tel {
                float: right;
            }
        }
        .mes2-box {
            font-size: px2rem(24);
            color: #666;
            margin-top: px2rem(29);
            .no {
                float: left;
            }
            .icon-right {
                float: left;
                width: px2rem(24);
                height: px2rem(24);
                @include bg-image("../images/icon_rightarrow");
                background-size: 100% 100%;
                margin-top: px2rem(6);
                margin-left: px2rem(8);
            }
            .again {
                float: right;
                color: #fc9153;
            }
            .count {
                float: right;
                color: #ccc;
            }
        }
    }
}
</style>
